import { useQuery } from 'react-query';
import { z } from 'zod';

import { queryKey } from '../documents.query-keys';
import { getDocumentChapterGroupDocuments } from '../infrastructure/get-document-chapters';

export const useGetDocumentChaptersGroupQuery = (documentId: string) => {
    return useQuery({
        queryKey: [queryKey.documents(), documentId],
        queryFn: () => getDocumentChapterGroupDocuments(documentId),
        onError(error) {
            if (error instanceof z.ZodError) {
                console.log('error from useGetDocumentQuery', error);
            }
        },
    });
};
